/**
 * Splits an array of nodes into subarrays of nodes, separating them
 * based on a given node type.
 *
 * For example: [<ol>, <ul>, <p>, <ol>] => [[<ol, <ul>], <p>, [<ol>]]
 *
 * @param   {Array}  nodes         The list of nodes to split
 * @param   {object} separatorType The node type to split with
 *
 * @returns {Array} A list containing node sublists and nodes of the separatorType
 */
export const splitNodes = (nodes, separatorType) => {

	const result = [];

	let i = 0;

	while (i < nodes.length) {

		let node = nodes[i];

		if (node.type === separatorType) {

			result.push(node);
			i += 1;

		} else {

			const group = [];

			while (node && node.type !== separatorType) {

				group.push(node);
				i += 1;
				node = nodes[i];

			}

			if (group.length > 0) {

				result.push(group);

			}

		}

	}

	return result;

};
